import { useStrictLocalization } from "@faire/web--source/common/localization";
import React from "react";

import {
  CloseModalButton,
  NeedMoreHelpButton,
  NextStepButton,
  SubmitButton,
} from "../components/NavigationButtons";
import { STEP } from "../consts";
import { useLoggedOutContactUsNavigation } from "../hooks/useLoggedOutContactUsNavigation";
import { useLoggedOutEmailTicket } from "../hooks/useLoggedOutEmailTicket";

export const LoggedOutContactUsStepCta: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const { nextBtnDisabled, closeModal, goToNextStep, currentStep } =
    useLoggedOutContactUsNavigation();
  const { submitTicket, isLoggedOutSubmitDisabled } = useLoggedOutEmailTicket();

  switch (currentStep) {
    case STEP.LOGGED_OUT_SELECT_TOPIC:
      return (
        <NextStepButton disabled={nextBtnDisabled()} onClick={goToNextStep} />
      );
    case STEP.HELP_CENTER_ARTICLE:
      return (
        <NeedMoreHelpButton
          disabled={nextBtnDisabled()}
          onClick={goToNextStep}
        />
      );
    case STEP.CONFIRMATION:
      return <CloseModalButton onClick={closeModal} />;
    case STEP.LOGGED_OUT_CONTACT_US:
      return (
        <SubmitButton
          disabled={isLoggedOutSubmitDisabled()}
          onClick={() => submitTicket(strictLocalize)}
        />
      );
    default:
      return (
        <NextStepButton disabled={nextBtnDisabled()} onClick={goToNextStep} />
      );
  }
};
